export const objectMap = <T extends Record<string, any>, U>(
  object: T,
  mapFn: (value: T[keyof T], key: keyof T) => U
): { [K in keyof T]: U } => {
  return Object.keys(object).reduce((result, key) => {
    result[key as keyof T] = mapFn(object[key as keyof T], key as keyof T);
    return result;
  }, {} as { [K in keyof T]: U });
};